'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppendNew = exports.Delete = exports.Detach = exports.SetColor = exports.Rename = exports.Open = exports.DragHandle = exports.Hamburger = undefined;

var _class, _temp;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./Icons.pcss');

var Hamburger = exports.Hamburger = function (_Component) {
  _inherits(Hamburger, _Component);

  function Hamburger() {
    _classCallCheck(this, Hamburger);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Hamburger).apply(this, arguments));
  }

  _createClass(Hamburger, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { className: styles.hamburger, height: '24', width: '24', viewBox: '0 0 24 24' },
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#000000', fill: 'none',
          d: 'M 5 12 L 19 12' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#000000', fill: 'none',
          d: 'M 5 7 L 19 7' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#000000', fill: 'none',
          d: 'M 5 17 L 19 17' })
      );
    }
  }]);

  return Hamburger;
}(_react.Component);

var DragHandle = exports.DragHandle = (_temp = _class = function (_Component2) {
  _inherits(DragHandle, _Component2);

  function DragHandle() {
    _classCallCheck(this, DragHandle);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(DragHandle).apply(this, arguments));
  }

  _createClass(DragHandle, [{
    key: 'render',
    value: function render() {
      var cn = (0, _classnames2.default)(styles.dragHandle, this.props.hover && styles.hover);
      return _react2.default.createElement(
        'svg',
        { className: cn, height: '24', width: '24', viewBox: '0 0 24 24' },
        _react2.default.createElement('path', {
          d: 'M 8.9999995,8 C 10.1,8 11,7.1 11,6 11,4.9 10.1,4 8.9999995,4 c -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 15,14 c 1.1,0 2,-0.9 2,-2 0,-1.1 -0.9,-2 -2,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 8.9999995,14 C 10.1,14 11,13.1 11,12 c 0,-1.1 -0.9,-2 -2.0000005,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 15,20 c 1.1,0 2,-0.9 2,-2 0,-1.1 -0.9,-2 -2,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 8.9999995,20 C 10.1,20 11,19.1 11,18 c 0,-1.1 -0.9,-2 -2.0000005,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z M 15,8 c 1.1,0 2,-0.9 2,-2 0,-1.1 -0.9,-2 -2,-2 -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 z m 0,0',
          fill: '#000000' })
      );
    }
  }]);

  return DragHandle;
}(_react.Component), _class.propTypes = {
  hover: _react.PropTypes.bool
}, _temp);

var Open = exports.Open = function (_Component3) {
  _inherits(Open, _Component3);

  function Open() {
    _classCallCheck(this, Open);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Open).apply(this, arguments));
  }

  _createClass(Open, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { height: '14', width: '17', viewBox: '0 0 18 18' },
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#232323', fill: 'none',
          fillRule: 'evenodd', d: 'M 8 0.88 L 15 8 L 8 15.12' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#232323', fill: 'none',
          fillRule: 'evenodd', d: 'M 0 8 L 14 8' })
      );
    }
  }]);

  return Open;
}(_react.Component);

var Rename = exports.Rename = function (_Component4) {
  _inherits(Rename, _Component4);

  function Rename() {
    _classCallCheck(this, Rename);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Rename).apply(this, arguments));
  }

  _createClass(Rename, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { height: '16', width: '16', viewBox: '0 0 16 16' },
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 13 1 L 13 15' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 1 4 L 10 4 L 10 12 L 1 12 L 1 4 Z M 1 4' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 16 1 L 9.94 1' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 16 15 L 9.94 15' })
      );
    }
  }]);

  return Rename;
}(_react.Component);

var SetColor = exports.SetColor = function (_Component5) {
  _inherits(SetColor, _Component5);

  function SetColor() {
    _classCallCheck(this, SetColor);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(SetColor).apply(this, arguments));
  }

  _createClass(SetColor, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { height: '17', width: '14', viewBox: '0 0 14 17' },
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'square', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 7 16 L 7 9 L 13 7.13 L 13 4.13' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 1 1 L 13 1 L 13 5 L 1 5 L 1 1 Z M 1 1' })
      );
    }
  }]);

  return SetColor;
}(_react.Component);

var Detach = exports.Detach = function (_Component6) {
  _inherits(Detach, _Component6);

  function Detach() {
    _classCallCheck(this, Detach);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Detach).apply(this, arguments));
  }

  _createClass(Detach, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { height: '16', width: '16', viewBox: '0 0 16 16' },
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 7 15 L 4 10 L 7 6 L 4 1' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 12 15 L 9 10 L 12 6 L 9 1' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 0 8 L 6.05 8' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 10.14 8 L 16 8' })
      );
    }
  }]);

  return Detach;
}(_react.Component);

var Delete = exports.Delete = function (_Component7) {
  _inherits(Delete, _Component7);

  function Delete() {
    _classCallCheck(this, Delete);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Delete).apply(this, arguments));
  }

  _createClass(Delete, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { height: '17', width: '14', viewBox: '0 0 14 17' },
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 1 4 L 13 4 L 13 7 L 1 7 L 1 4 Z M 1 4' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 2 7 L 2 16 L 12 16 L 12 7 L 2 7 Z M 2 7' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 5 4 L 5 1 L 9 1 L 9 4 L 5 4 Z M 5 4' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 9 9 L 9 14 L 9 9 Z M 9 9' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 5 9 L 5 14 L 5 9 Z M 5 9' })
      );
    }
  }]);

  return Delete;
}(_react.Component);

var AppendNew = exports.AppendNew = function (_Component8) {
  _inherits(AppendNew, _Component8);

  function AppendNew() {
    _classCallCheck(this, AppendNew);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(AppendNew).apply(this, arguments));
  }

  _createClass(AppendNew, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { height: '16', width: '16', viewBox: '0 0 16 16' },
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 0 8 L 16 8' }),
        _react2.default.createElement('path', { strokeLinejoin: 'miter', strokeLinecap: 'butt', strokeWidth: '2', stroke: '#323232', fill: 'none',
          fillRule: 'evenodd', d: 'M 8 0 L 8 16' })
      );
    }
  }]);

  return AppendNew;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/ReactIcons/Icons.js
// module id = 558
// module chunks = 1